export enum CompanyRoleEnum {
  owner = 'owner',
  true_owner = 'true_owner',
  other = 'other',
}

export const COMPANY_ROLE_LABELS: Record<CompanyRoleEnum, string> = {
  [CompanyRoleEnum.owner]: 'Owner',
  [CompanyRoleEnum.true_owner]: 'True Owner',
  [CompanyRoleEnum.other]: 'Other',
};

export const companyPropertyRoles = Object.values(CompanyRoleEnum).map((role) => ({
  text: COMPANY_ROLE_LABELS[role],
  value: role,
}));

export const companyRoles = companyPropertyRoles.map((role) => ({
  ...role,
  text: `${role.text} Company`,
}));
